import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { Permission as PermissionAlias } from "../../customerservice/models/permission";

export class Utils {

    static momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    public static validateSpecialCharacterRule(value: string, allowedChars: string[]): Boolean {
        if (value === undefined || value === null) return undefined;
        let valid = true;
        let pattern = /[\w\s]+/g;
        let stripped = value.replace(pattern, '');
        for (let char of stripped) {
            valid = (allowedChars.indexOf(stripped) === -1) ? false : true;
        }
        return valid;
    }


    public static alphabeticalCharacterRule(amount: number): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            let value: string = control.value;
            if (value.length === 0) {
                return undefined;
            }
            let pattern = /[^A-Za-z]+/g;
            let stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'alphabeticalCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };

    public static digitCharacterRule(amount: number): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            let value: string = control.value;
            if (value.length === 0) {
                return undefined;
            }
            let pattern = /[^0-9\.]+/g;
            let stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'digitCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };

    public static lowercaseCharacterRule(amount: number): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            let value: string = control.value;
            if (value.length === 0) {
                return undefined;
            }
            let pattern = /[^a-z]+/g;
            let stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'lowercaseCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };

    public static uppercaseCharacterRule(amount: number): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            let value: string = control.value;
            if (value.length === 0) {
                return undefined;
            }
            let pattern = /[^A-Z]+/g;
            let stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'uppercaseCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };

    public static specialCharacterRule(amount: number): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            let value: string = control.value;
            if (value.length === 0) {
                return undefined;
            }
            let pattern = /[\w\s]+/g;

            let stripped = value.replace(pattern, '');
            if (stripped.length < amount) {
                return { 'specialCharacterRule': { 'required': amount, 'actual': stripped.length } };
            }
            return undefined;
        };
        return validator;
    };

    public static allowedSpecialCharacterRule(allowedChars: string[]): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            let value: string = control.value;
            let valid = true;
            let invalidChars: string[] = [];

            let pattern = /[\w\s]+/g;
            let stripped = value.replace(pattern, '');
            for (let char of stripped) {
                if (allowedChars.indexOf(char) === -1) {
                    valid = false;
                    invalidChars.push(char);
                }
            }
            if (!valid) {
                return { 'allowedCharacterRule': { 'invalidChars': invalidChars, 'allowedChars': allowedChars } };
            }
            return undefined;
        };
        return validator;
    };

    public static noEmptyString(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length != control.value.trim().length && control.value.trim().length === 0) {
            return { 'noEmptyString': true };
        }
        return undefined;
    };

    public static alphaNumericCharacterValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let alphaNumericPattern = /[^A-Za-z0-9\s]+/g;
        if (new RegExp(alphaNumericPattern).test(value)) {
            return { 'alphaNumericValidation': true };
        }
        return undefined;
    };

    public static numericCharacterValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let numericPattern = /[^0-9\.]+/g;
        if (new RegExp(numericPattern).test(value)) {
            return { 'numericValidation': true };
        }
        return undefined;
    };
    public static customValidationForQty(Qty: number, disputedQty: number): ValidatorFn {
        const validator = (control: AbstractControl): { [key: string]: any } => {
            if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
            if ((+disputedQty === 0 && (+control.value) === 0) || ((+control.value) < 0)) {
                return { 'quantityValidation': true };
            }
            return undefined;
        };
        return validator;
    };



    public static passwordValidationRule(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let pattern = "/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/";
        if (new RegExp(pattern).test(control.value)) {
            return { 'passwordValidationRule': true };
        }
        return undefined;
    };
    public static emailValidationRule(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        //let pattern = "/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$/";
        if (!(/^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(control.value.trim()))) {
            return { 'emailValidationRule': true };
        }
        return undefined;
    };

    public static validateEmailFormat(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(control.value.trim()))) {
            return { 'emailValidationRule': true };
        }
        return undefined;
    };

    public static groupBy(array: any, f: any) {
        var groups = {};
        array.forEach(function (o: any) {
            var group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        })
    }

    public static groupByList(list: any, fn: any) {
        var groups = {};
        for (var i = 0; i < list.length; i++) {
            var group = JSON.stringify(fn(list[i]));
            if (group in groups) {
                groups[group].push(list[i]);
            } else {
                groups[group] = [list[i]];
            }
        }

        return groups;

    }

    public static groupByArray(value: Array<any>, field: string): Array<any> {
        const groupedObj = value.reduce((prev, cur) => {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            } else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        return Object.keys(groupedObj).map(key => ({ key, value: groupedObj[key] }));
    }

    public static isPermissionAvailable(permissions: PermissionAlias[], headerText: string): Boolean {

        if (permissions && headerText)
            return !(permissions.map(x => x.permissionName).indexOf(headerText) >= 0);
        else
            return false;
    }
    public static validateNumericCharacterRule(value: string): Boolean {
        if (value === undefined || value === null) return undefined;
        let valid = true;
        let numericPattern = /[^0-9\.]+/g;
        if (new RegExp(numericPattern).test(value)) {
            valid = false;
        }
        return valid;
    }
    public static searchByMemberValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let numberPattern = /^[0-9]+$/;
        let distributorIDPattern1 = /^[0-9]{12}$/;
        let distributorIdPattern2 = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        let emailPattern = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
        let phoneNumberPattern = /^[0-9]{10}$/;
        let distributorIDpattern = /^[0-9-]+$/;
        if (value.match(numberPattern)) {
            if ((!new RegExp(phoneNumberPattern).test(value)) && value.length < 10) {
                return { 'phoneNumberValidation': true };
            }
            else if ((!new RegExp(distributorIDPattern1).test(value)) && value.length > 10) {
                return { 'distributorIDValidation1': true };
            }
        }
        else if (value.match(distributorIDpattern)) {
            if (!new RegExp(distributorIdPattern2).test(value)) {
                return { 'distributorIDValidation2': true };
            }
        }
        else if (!new RegExp(emailPattern).test(value)) {
            return { 'mailIDvalidation': true };
        }
        return undefined;
    };

    public static validateStartDate(control: AbstractControl): { [key: string]: boolean } {
        const characterCheck = /[a-zA-z]/;
        if (control.value === undefined || control.value === null || control.value instanceof Array) {
            return null;
        }
        let value = control.value;
        if (value.length === 0) {
            return undefined;
        }
        // tslint:disable-next-line:max-line-length
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');

        } else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        } else if (value && (typeof value === 'string')) {
            value = value;
        }
        value = value.toLowerCase();
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        } else {
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            } else {
                if (control.parent.controls['endDate'].valid) {
                    let endDate = control.parent.controls['endDate'].value;
                    if (endDate && endDate._i && (typeof endDate._i === 'object')) {
                        endDate = Utils.momentConstructor(endDate._d).format('DD-MMM-YYYY');

                        // moment(endDate._i, 'DD-MMM-YYYY').format('DD-MMM-YYYY');
                    } else if (endDate && endDate._i && (typeof endDate._i === 'string')) {
                        endDate = endDate._i;
                    }
                    if (endDate && endDate.length === 10) {
                        endDate = moment(endDate, 'DD-MM-YYYY').format('MM/DD/YYYY');
                    } else {
                        endDate = moment(endDate, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    }
                    if (value.length === 10) {
                        value = moment(value, 'DD-MM-YYYY').format('MM/DD/YYYY');
                    } else {
                        value = moment(value, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    }
                    const endDateValue = new Date(endDate);
                    const startDateValue = new Date(value);
                    if (endDateValue && endDateValue < startDateValue) {
                        return { 'startDateValidation': true };
                    }

                }
                const currentDate = Utils.momentConstructor(new Date()).format('DD-MMM-YYYY');
                const selectedDate = Utils.momentConstructor(value).format('DD-MMM-YYYY');
                const selectedStartDate = selectedDate.split('-');
                const currentDay = currentDate.split('-');
                if (selectedStartDate[1] !== currentDay[1] || selectedStartDate[2] !== currentDay[2]
                    || selectedStartDate[1] === currentDay[1] && selectedStartDate[2] === currentDay[2]
                    && selectedStartDate[0] > currentDay[0]) {
                    return { 'inValidStartDate': true };
                }
            }
        }
        return undefined;
    }

    public static validateEndDate(control: AbstractControl): { [key: string]: boolean } {
        const characterCheck = /[a-zA-z]/;
        let value = control.value;
        if (control && control.errors && control.errors.owlDateTimeParse) {
            return { 'dateValidation': true };
        }
        if (!value || (value && value.length === 0) || value instanceof Array) {
            return undefined;
        }
        // tslint:disable-next-line:max-line-length
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        } else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        }
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        }
        else {
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            }
            else {
                if (control.parent.controls['startDate']) {
                    let startDate = control.parent.controls['startDate'].value;
                    if (startDate && startDate._i && (typeof startDate._i === 'object')) {
                        // startDate = moment(startDate._i, 'DD-MMM-YYYY').format('DD-MMM-YYYY');;
                        startDate = Utils.momentConstructor(startDate._d).format('DD-MMM-YYYY');
                    } else if (startDate && startDate._i && (typeof startDate._i === 'string')) {
                        startDate = startDate._i;
                    }
                    if (startDate && startDate.length === 10) {
                        startDate = moment(startDate, 'DD-MM-YYYY').format('MM/DD/YYYY');
                    } else {
                        startDate = moment(startDate, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    }
                    if (value && value.length === 10) {
                        value = moment(value, 'DD-MM-YYYY').format('MM/DD/YYYY');
                    } else {
                        value = moment(value, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    }
                    const startDateValue = new Date(startDate);
                    const endDateValue = new Date(value);
                    if (startDateValue > endDateValue) {
                        return { 'EndDateValidation': true };
                    }
                }
            }
        }
        return undefined;
    }

    public static validateFromDate(dateRangeDuration?: any, unitOfTime?: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
        const characterCheck = /[a-zA-z]/;
        if (control.value === undefined || control.value === null || control.value instanceof Array) {
            return { 'dateValidation': true };
        }
        let value = control.value;
        if (value.length === 0) {
            return undefined;
        }
        // tslint:disable-next-line:max-line-length
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        }
        else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        }
        else if (value && (typeof value === 'string')) {
            value = value;
        }
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        }
        else {
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            }
            else {
                if (control.parent.controls['toDate'].valid) {
                    let toDate = control.parent.controls['toDate'].value;
                    if (toDate && toDate._i && (typeof toDate._i === 'object')) {
                        toDate = Utils.momentConstructor(toDate._d).format('DD-MMM-YYYY');
                    } else if (toDate && toDate._i && (typeof toDate._i === 'string')) {
                        toDate = toDate._i;
                    }
                    toDate = moment(toDate, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    value = moment(value, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    const toDateValue = new Date(toDate);
                    const fromDateValue = new Date(value);
                    if (toDateValue < fromDateValue) {
                        return { 'fromDateValidation': true };
                    } else if (dateRangeDuration) {
                        if (unitOfTime === 'M') {
                            const durationSubtractedDate = moment(toDate).subtract(dateRangeDuration, 'M');
                            const isBetween = moment(value).isBetween(durationSubtractedDate, toDate, undefined, '[]');
                            if (!isBetween) {
                                return { 'monthRangeValidation': true };
                            }
                        } else if (unitOfTime === 'd') {
                            const isSame = moment(value).isSame(toDate);
                            if (!isSame) {
                                return { 'dayRangeValidation': true };
                            }
                        }
                    }
                }
            }
        }
        return null;
        };
    }

    public static validateToDate(dateRangeDuration?: any, unitOfTime?: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
        const characterCheck = /[a-zA-z]/;
        if (control.value === undefined || control.value === null || control.value instanceof Array) {
            return { 'dateValidation': true };
        }
        let value = control.value;
        if (value.length === 0) {
            return undefined;
        }
        // tslint:disable-next-line:max-line-length
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        } else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        }
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        }
        else {
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            } else {
                value = Utils.momentConstructor(value).format('DD-MMM-YYYY');
                if (control.parent.controls['fromDate'].valid) {
                    let fromDate = control.parent.controls['fromDate'].value;
                    if (fromDate && fromDate._i && (typeof fromDate._i === 'object')) {
                        fromDate = Utils.momentConstructor(fromDate._d).format('DD-MMM-YYYY');
                    } else if (fromDate && fromDate._i && (typeof fromDate._i === 'string')) {
                        fromDate = fromDate._i;
                    }
                    fromDate = moment(fromDate, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    value = moment(value, 'DD-MMM-YYYY').format('MM/DD/YYYY');
                    const fromDateValue = new Date(fromDate);
                    const toDateValue = new Date(value);
                    if (fromDateValue > toDateValue) {
                        return { 'toDateValidation': true };
                    } else if (dateRangeDuration) {
                        if (unitOfTime === 'M') {
                            const durationAddedDate = moment(fromDate).add(dateRangeDuration, 'M');
                            const isBetween = moment(value).isBetween(fromDate, durationAddedDate, undefined, '[]');
                            if (!isBetween) {
                                return { 'monthRangeValidation': true };
                            }
                        } else if (unitOfTime === 'd') {
                            const isSame = moment(value).isSame(fromDate);
                            if (!isSame) {
                                return { 'dayRangeValidation': true };
                            }
                        }
                    }
                }
            }
        }
        return null;
        };
    }

    public static validateDate(control: AbstractControl): { [key: string]: boolean } {
        const characterCheck = /[a-zA-z]/;
        let scope = this;
        const findNumber = '^[0-9]*$';
        if (control.value === undefined || control.value === null || control.value instanceof Array) {
            return { 'dateValidation': true };
        }
        let value = control.value;
        if (value.length === 0) {
            return undefined;
        }
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        } else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        }
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        }
        else {
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            }
            else {
                const selectedDate = value.split("-");
                selectedDate[1] = Utils.formatMonth(selectedDate[1]);
                if (new Date(selectedDate[2] + "/" + selectedDate[1] + "/" + selectedDate[0]).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                    return { 'lessThanCurrentDate': true };
                }

            }
        }
        return undefined;
    };


    public static validateFutureDate(control: AbstractControl): { [key: string]: boolean } {
        const characterCheck = /[a-zA-z]/;
        let scope = this;
        const findNumber = '^[0-9]*$';
        if (control.value === undefined || control.value === null || control.value instanceof Array) {
            return { 'dateValidation': true };
        }
        let value = control.value;
        if (value.length === 0) {
            return undefined;
        }
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        } else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        }
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        }
        else {
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            }
            else {
                const selectedDate = value.split("-");
                selectedDate[1] = Utils.formatMonth(selectedDate[1]);
                if (new Date(new Date(selectedDate[2] + "-" + selectedDate[1] + "-" + selectedDate[0]).getTime() + (new Date().getTimezoneOffset() * 60000)) <= new Date()) {
                    return { 'lessThanOrEqualToCurrentDate': true };
                }

            }
        }
        return undefined;
    };


    public static validateDateOfBirth(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) {
            return { 'dateValidation': true };
        }
        let value = control.value;
        if (value.length === 0) {
            return undefined;
        }
        const datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec|jan|mar|may|jul|aug|oct|dec|JAN|MAR|MAY|JUL|AUG|OCT|DEC)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|jan|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|JAN|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb|feb|FEB))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|jan|feb|mar|apr|may|jun|jul|aug|sep|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP))|(?:1[0-2]|(?:Oct|Nov|Dec|oct|nov|dec|OCT|NOV|DEC)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (value && value._i && (typeof value._i === 'object')) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        } else if (value && value._i && (typeof value._i === 'string') && value._i.length > 11) {
            value = Utils.momentConstructor(value._d).format('DD-MMM-YYYY');
        } else if (value && value._i && (typeof value._i === 'string')) {
            value = value._i;
        }
        if (!(new RegExp(datepattern).test(value))) {
            return { 'dateValidation': true };
        } else {
            const characterCheck = /[a-zA-z]/;
            if ((value && value.length < 10 && characterCheck.test(value[3])) || (value && value.length < 9 && !characterCheck.test(value[3]))) {
                return { 'dateValidation': true };
            }
            else {
                if (value && value.length >= 9) {
                    const characterCheck = /[a-zA-z]/;
                    let dateOfBirth = '';
                    if (characterCheck.test(value[3])) {
                        dateOfBirth = moment(value, 'DD-MMM-YYYY').format('DD-MM-YYYY');
                    } else {
                        dateOfBirth = value;
                    }

                    const dateParts = dateOfBirth.split('-');
                    if (dateParts[2] && dateParts[2].length === 4) {
                        const eighteenYearsBeforeNow = new Date(+dateParts[2] + 18, +dateParts[1] - 1, +dateParts[0]) <= new Date();
                        if (!eighteenYearsBeforeNow) {
                            return { 'eighteenYearsValidation': true };
                        }
                    } else {
                        return { 'dateValidation': true };
                    }
                }
            }
        }
        return undefined;
    }


    public static formatMonth(value) {
        value = value.toLowerCase();
        switch (value) {
            case 'jan': value = '01'; break;
            case 'feb': value = '02'; break;
            case 'mar': value = '03'; break;
            case 'apr': value = '04'; break;
            case 'may': value = '05'; break;
            case 'jun': value = '06'; break;
            case 'jul': value = '07'; break;
            case 'aug': value = '08'; break;
            case 'sep': value = '09'; break;
            case 'oct': value = '10'; break;
            case 'nov': value = '11'; break;
            case 'dec': value = '12'; break;
        }
        return value;
    }

    public static PhoneNumValidationRule(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let pattern = /^[0-9]*$/;
        if (!new RegExp(pattern).test(control.value)) {
            return { 'phoneNumberValidation': true };
        }
        return undefined;
    };

    public static PhoneNumLengthValidationRule(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let length = 10;
        if (control.value.length < length) {
            return { 'phoneNumberLengthValidation': true };
        }
        return undefined;
    };

    public static amountValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let amountPattern = /^[0-9]+(\.[0-9]{1,2})?$/;
        if (!(new RegExp(amountPattern).test(value))) {
            return { 'amountValidation': true };
        }
        return undefined;
    };

    public static moneyOrderAmountValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let amountPattern = /^[0-9]+(\.[0-9]{1,2})?$/;
        if (!(new RegExp(amountPattern).test(value))) {
            return { 'amountValidation': true };
        }
        // if (+value === 0) {
        //     return { 'amountValidation': true };
        // }
        return undefined;
    };

    public static alphaNumericIphenCharacterValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null || control.value instanceof Array) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let alphaNumericPattern = /[^A-Za-z0-9-\s]+/g;
        if (new RegExp(alphaNumericPattern).test(value)) {
            return { 'alphaNumericValidation': true };
        }
        return undefined;
    };


    public static convertUTCtoStoreDateTime = (timeZoneOffset) => {
        return new Date(new Date().getTime() + (timeZoneOffset * 3600000) + (new Date().getTimezoneOffset() * 60000));
    }

    public static convertToSpecificDateFormat(dateMomentObj: any, formatType:string) {
        const characterCheck = /[a-zA-z]/;
        if (dateMomentObj && typeof dateMomentObj._i === 'object') {
          dateMomentObj = dateMomentObj._d;
          dateMomentObj = this.momentConstructor(new Date(dateMomentObj))
                .format(formatType);
        }
        if (dateMomentObj && typeof dateMomentObj._i === 'string') {
          dateMomentObj = dateMomentObj._i;
            const dateParts = dateMomentObj.split('-');
            if (characterCheck.test(dateParts[1])) {
              dateMomentObj = moment(dateMomentObj,'DD-MMM-YYYY').format(formatType);
            } else {
              dateMomentObj =moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
              .format(formatType);
            }
        }
        return dateMomentObj;
      }
     
}


// WEBPACK FOOTER //
// ./src/app/shared/Utils/utils.ts